// src/components/PageHeader.tsx
import React from 'react';
import './PageHeader.css';

interface PageHeaderProps {
  icon: string;
  title: string;
  description: string;
  actions?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  icon,
  title,
  description,
  actions
}) => {
  return (
    <div className="page-header">
      <div className="header-content">
        <h1 className="page-title">{icon} {title}</h1>
        <p className="page-description">{description}</p>
      </div>
      {actions && (
        <div className="header-actions">
          {actions}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
